module.exports = __webpack_public_path__ + "img/slide03_sp.17e709d3.png";